class VideoTracking {
    static trackingVideoEvent(videoLink, eventCategory, title, eventContent) {
        console.log("VideoTracking----->", videoLink, eventCategory, title, eventContent);
        if (typeof window._amcAnalytic_action == "undefined") {
            console.log("window._amcAnalytic_action is not defined");
            return;
        } else {
            window._amcAnalytic_action.visitVideo({
                videoLink,
                eventCategory,
                title,
                eventContent,
            });
        }
    }
}

document.addEventListener("DOMContentLoaded", function () {
    $(".camc-local-video").on("play", function (event) {
        try {
            // local video tracking do not need eventContent field
            const eventContent = "";
            const clickedElement = event.currentTarget;
            const videoLink = clickedElement.querySelector("source").src;
            const eventCategory = "local";
            const title = clickedElement.getAttribute("data-title") || "Local Video";
            VideoTracking.trackingVideoEvent(videoLink, eventCategory, title, eventContent);
            $(event.currentTarget).off("play");
        } catch {
            console.log("camc single local video tracking error");
        }
    });

    $(".single-youku-video__item").on("click.youkuVideoTracking", function (event) {
        const clickedElement = event.currentTarget;
        try {
            if (clickedElement.classList.contains("single-youku-video__item--error")) {
                return;
            }
            const videoLink = clickedElement.getAttribute("data-url") || "";
            const eventCategory = "youku";
            const title = clickedElement.getAttribute("data-title") || "";
            const eventContent = clickedElement.getAttribute("data-video-id") || "";
            VideoTracking.trackingVideoEvent(videoLink, eventCategory, title, eventContent);
            $(event.currentTarget).off("click.youkuVideoTracking");
        } catch (error) {
            console.log("camc single youku video tracking error");
        }
    });
});

export { VideoTracking };
